import { InputHTMLAttributes } from 'react';
import styled from 'styled-components';
import { theme } from 'styles/theme';

export interface ITextInput extends Omit<InputHTMLAttributes<HTMLInputElement>, 'children'> {
  label?: string;
  id?: string;
  name?: string;
  error?: string;
}

const TextInput = ({ label, id, name, error, ...props }: ITextInput): JSX.Element => {
  const inputId = id || (label ? label.replace(/\s+/g, '-').toLowerCase() : undefined);

  return (
    <>
      {label && <Label htmlFor={inputId}>{label}</Label>}
      <Input $error={!!error} id={inputId} name={name} aria-label={label} {...props} />
      <Error $error={!!error}>{error}</Error>
    </>
  );
};

export default TextInput;

const Input = styled.input<{ $error: boolean }>`
  width: 100%;
  height: 48px;
  border-radius: 20px;
  outline: none;
  background-color: #fff;
  box-shadow: none;
  padding: 12px 14px;
  line-height: 1.5rem;
  font-size: 1rem;
  border: 2px solid
    ${(props) => (props.$error ? theme.colors.remondis_accent : 'rgba(0, 0, 0, 0.1)')};

  transition: border 0.3s ease;

  &:focus {
    border-color: ${(props) =>
      props.$error ? theme.colors.remondis_accent : 'rgba(0, 0, 0, 0.5)'};
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  }

  &::placeholder {
    text-align: start;
    color: #000;
    opacity: 0.3;
  }

  &:invalid {
    border: 2px solid red;
  }
`;

const Label = styled.label`
  /* font-family: var(--secondary-font); */
  font-size: 1rem;
  font-weight: 700;
  color: #000;
  margin: 0 0 1rem;
`;

const Error = styled.p<{ $error: boolean }>`
  max-height: ${(props) => (props.$error ? '100px' : '0')};
  opacity: ${(props) => (props.$error ? '1' : '0')};
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease;
  color: ${theme.colors.remondis_accent};
  font-size: 0.875rem;
  margin: 4px 0 0 6px;
  font-weight: bold;
  overflow: hidden;
`;
